const menuDashboard = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
      <g fill="none" fill-rule="evenodd" transform="translate(1 -1)">
        <g stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round" transform="translate(0 .75)">
          <polyline points="2.625 9.375 2.625 16.875 7.125 16.875 7.125 11.625 10.875 11.625 10.875 16.875 15.375 16.875 15.375 9.75"/>
          <polyline points=".375 9 9 .375 17.625 9"/>
          <polyline points="12 1.125 14.625 1.125 14.625 3.75"/>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>
`;

export default menuDashboard;
